import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import isFolderOrSubFolderOfDistinguishedFolder from './isFolderOrSubFolderOfDistinguishedFolder';
import type SearchTableQuery from 'mini-mail-list-store/lib/store/schema/SearchTableQuery';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { type TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';

export const doesTableHasJunkItems = (tableView: TableView): boolean => {
    if (tableView.tableQuery.type === 1) {
        return (
            (tableView.tableQuery as SearchTableQuery).searchFolderScopeId ===
            folderNameToId('junkemail')
        );
    }

    return isFolderOrSubFolderOfDistinguishedFolder(tableView.tableQuery.folderId, 'junkemail');
};
